// Base for all  subscription-related requests that can be made by the user.
export interface UserSubscriptionParams_Base {
  action: string;
};

export interface UserSubscriptionResult_Base {
  error?: string; // empty if all is ok
};

export interface UserSubscriptionParams_ChangeProduct extends UserSubscriptionParams_Base {
  action: 'ChangeProduct';
  newProductId: number;
};

export enum CheckoutResult {
  Fulfilled = 'fulfilled',
  Declined = 'declined',
  Review = 'review',
  Waiting = 'waiting',
};

// Called when the client is redirected after a purchase
export interface UserSubscriptionParams_CheckoutRedirect extends UserSubscriptionParams_Base {
  action: 'CheckoutRedirect';
  checkoutResult: CheckoutResult
  checkoutId: string;
};

export interface UserSubscriptionResult_CheckoutRedirect extends UserSubscriptionResult_Base {
  token?: string;
  androidInstallUrl?: string; // Play Store install URL with claim token in referrer (for post-purchase install badge)
  iosInstallUrl?: string;     // App Store install URL (for post-purchase install badge)
};

export interface UserSubscriptionParams_Cancel extends UserSubscriptionParams_Base {
  action: 'Cancel_NOT_IMPLEMENTED';
};

export interface UserSubscriptionParams_Resume extends UserSubscriptionParams_Base {
  action: 'Resume_NOT_IMPLEMENTED';
};

export interface UserSubscriptionParams_SendLoginEmail extends UserSubscriptionParams_Base {
  action: 'SendLoginEmail';
};

export type UserSubscriptionParams =
  UserSubscriptionParams_ChangeProduct |
  UserSubscriptionParams_CheckoutRedirect |
  UserSubscriptionParams_Cancel |
  UserSubscriptionParams_Resume |
  UserSubscriptionParams_SendLoginEmail;

export type UserSubscriptionResult = UserSubscriptionResult_Base | UserSubscriptionResult_CheckoutRedirect;
